export enum FinancialItemRelatesTo {
    ORGANISATION = 1,
    PROPERTIES = 2,
    PROP_ROOM_TENANCY = 3,
}

export const FinancialItemRelatesToReverse = {
    '1': 'Organisation',
    '2': ''
}
